module.exports = __webpack_public_path__ + "static/img/template_img_09.ccef6493.jpg";